module.exports = __webpack_public_path__ + "img/court-logo.46478995.png";